import { Heading1 } from 'components/shared/Typography';
import styled from 'styled-components';
import { color, container, fontSize, screen, spacing } from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledHero = styled.div`
  background-image: ${() =>
    `url('${getPublicPath('/images/memberGetMember/bg-hero.svg')}')`};
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: cover;
  padding: 0 ${spacing('md')};
  margin-bottom: ${spacing('xl')};

  @media (min-width: ${screen('lg')}) {
    padding: ${spacing('xl4')} ${spacing('xl')} ${spacing('md')};
    background-size: cover;
    background-position: center bottom;
    margin-bottom: ${spacing('xl4')};
  }
`;

export const StyledHeroContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  padding-top: ${spacing('xl2')};
  padding-bottom: ${spacing('xl2')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};
  z-index: 1;
  position: relative;

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
    align-items: flex-start;
    padding-bottom: ${spacing('xl6')};
  }
`;

export const StyledHeroText = styled.div`
  max-width: ${container('xs')};
  color: ${color('text_white')};
  line-height: 1.5;
  text-align: center;
  margin: auto;

  @media (min-width: ${screen('lg')}) {
    text-align: left;
    font-size: ${fontSize('lg')};
    line-height: 1.4;
    margin: unset;
    margin-bottom: ${spacing('xl3')};
  }
`;

export const StyledHeroTitle = styled(Heading1)`
  margin-bottom: ${spacing('lg')};
`;

export const StyledHeroVideoContainer = styled.div`
  flex-grow: 1;
`;

export const StyledHeroVideo = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
